function e() {
  try {
    typeof window != "undefined" && typeof console != "undefined" && console.log ? console.log("%c@oppein/op-web-components v1.0.221", "color: #409eff; font-weight: bold;") : typeof console != "undefined" && console.log && console.log("@oppein/op-web-components v1.0.221");
  } catch (o) {
    console.warn("Failed to log package version:", o);
  }
}
e();
export {
  e as logPackageVersion
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/logVersion.js
// module id = 1299
// module chunks = 41